// Bramka „Załóż firmę lub przyjmij zaproszenie" (decyzja D2 z docs/model-kluczy-firmowych.md).
//
// Konto może istnieć BEZ firmy, ale wtedy nic nie może zrobić — w modelu docelowym każda
// ścieżka zapisu kończy się 409 {code:'NoWorkspace'}, a interfejs zamiast pustych list
// pokazuje ten ekran.
//
// Zamontowany w components/ProtectedRoute (potomek CompanyProvider) — tam, a nie wyżej
// w App.tsx, bo ProtectedRoute musi wcześniej wykonać przekierowania na /activation
// i /recovery; konto bez firmy bywa też kontem jeszcze nieaktywowanym.
// O pokazaniu decyduje shouldShowNoCompanyGate() — patrz ./shouldShow.

import { useTranslation } from "react-i18next";

import Button from "components/Button";
import HollowButton from "components/HollowButton";

import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

const NoCompanyGate: FC<Props> = ({
  onCreateCompany,
  onAcceptInvitation,
  pendingInvitationsCount,
  className = "",
}) => {
  const { t } = useTranslation();

  const hasPending = (pendingInvitationsCount ?? 0) > 0;

  return (
    <div className={`${styles.wrapper} ${className}`}>
      <div className={styles.card}>
        <div className={styles.title}>
          {t("company.noCompany.title", {
            defaultValue: "Nie należysz jeszcze do żadnej kancelarii",
          })}
        </div>
        <div className={styles.description}>
          {t("company.noCompany.description", {
            defaultValue:
              "Dokumenty, sprawy i korespondencja należą do kancelarii, a dostęp do nich " +
              "daje członkostwo w niej. Załóż własną kancelarię albo poproś o zaproszenie " +
              "osobę, która już ją prowadzi.",
          })}
        </div>

        <div className={styles.buttons}>
          <Button
            onClick={onCreateCompany}
            text={t("company.noCompany.create", {
              defaultValue: "Załóż kancelarię",
            })}
          />
          {onAcceptInvitation && (
            <HollowButton
              onClick={() => onAcceptInvitation()}
              text={t("company.noCompany.invitation", {
                defaultValue: "Mam zaproszenie",
              })}
            />
          )}
        </div>

        {hasPending && (
          <div className={styles.hint}>
            {t("company.noCompany.pending", {
              defaultValue: "Masz oczekujące zaproszenia: {{count}}.",
              count: pendingInvitationsCount,
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default NoCompanyGate;
